import AADService from "./AADService";
import DEMO from "./store/constant";

const MAESTRO_ADMIN = DEMO.MAESTRO_ADMIN;
const MAESTRO_ADLS_ADMIN = DEMO.MAESTRO_ADLS_ADMIN;
const KUMHO_READER = DEMO.MAESTRO_MIRROR_READER_KUMHO;
const HYOSUNG_READER = DEMO.MAESTRO_MIRROR_READER_HYOSUNG;

let environment_dependant_params = {};

process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_RUN_ENV === "production"
  ? (environment_dependant_params.centralmeta_url =
    "https://westeurope.azuredatabricks.net/?o=7225458978966229")
  : process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_RUN_ENV === "development"
    ? (environment_dependant_params.centralmeta_url =
      "https://westeurope.azuredatabricks.net/?o=1848681866643747")
    : (environment_dependant_params.centralmeta_url =
      "https://westeurope.azuredatabricks.net/?o=1848681866643747");

/** Now menu items are restricted by putting accessTo in those menus to be accessible by only any admins.
 * Maestro-Admin is the super admin who will be able to access all the menu
 * adls-admin is admin for adls-gov
 * and by default Maestro-Requester is given access to the menu items**/
export const items = [
  {
    id: "navigation",
    title: "",
    type: "group",
    icon: "icon-navigation",
    children: [
      {
        id: "Admin",
        title: "Admin",
        type: "collapse",
        icon: "feather icon-box",
        accessTo: [MAESTRO_ADMIN],
        children: [
          {
            id: "usermgmt",
            title: "User Management",
            type: "item",
            // icon: "feather icon-users",
            url: "/ie/admin/usersmgmt",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "luisaddintentandutterance",
            title: "Luis Add Intent and Utterance",
            type: "item",
            url: "/ie/admin/luisAddIntentAndUtterance",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "luistrainingandpublish",
            title: "Luis Training And Publish",
            type: "item",
            url: "/ie/admin/luisTrainingAndPublish",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "createcategory",
            title: "Create Category",
            type: "item",
            url: "/ie/admin/createcategory",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "latestupdatefeed",
            title: "Latest Update Feed",
            type: "item",
            url: "/ie/admin/latestupdatefeed",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "aadadminfunction",
            title: "AAD Admin Function",
            type: "item",
            url: "/ie/admin/creategroups",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "verifyproduct",
            title: "Verify Product",
            type: "item",
            url: "/ie/admin/verifyproduct",
            accessTo: [MAESTRO_ADMIN],
          },
          {
            id: "spnrotate",
            title: "Service Prinicpal Rotate",
            type: "item",
            url: "/ie/admin/spnrotate",
            accessTo: [MAESTRO_ADMIN],
          },
        ],
      },
      {
        id: "Automation",
        title: "Automation",
        type: "collapse",
        icon: "feather icon-cloud-drizzle",
        children: [
          {
            id: "sso",
            title: "Self Service Onboarding",
            type: "item",
            // icon: "feather icon-navigation",
            url: "/ie/selfonboarding",
          },
          {
            id: "ApplicationDatasets",
            title: "GraphQL Access Request",
            type: "item",
            // icon: "feather icon-shield",
            url: "/ie/api/graphqlaccessrequest",
          },
          {
            id: "accessrequests",
            title: "AccessRequests",
            type: "item",
            // icon: "feather icon-bar-chart",
            url: "/ie/applications/approvalrequests",
          },
          {
            id: "loganalytics",
            title: "Log Analytics",
            type: "item",
            // icon: "feather icon-bar-chart",
            url: "/ie/applications/loganalytics",
          },
          {
            //ADO
            id: "DevOps",
            title: "DevOps",
            type: "collapse",
            // icon: "feather icon-box",
            children: [
              {
                id: "devopsmigration",
                title: "ADO Existing Project",
                type: "item",
                url: "/ie/ado/existingadounit",
              },
              {
                id: "devopsunit",
                title: "ADO Project & Team",
                type: "item",
                url: "/ie/ado/newadounit",
              },
              {
                id: "devopspipelineunit",
                title: "ADO Pipeline",
                type: "item",
                url: "/ie/ado/newadopipeline",
              },
              {
                id: "devopprojectslist",
                title: "ADO Projects List",
                type: "item",
                url: "/ie/ado/projectslist",
              },
            ],
          },
          {
            id: "versioncontrol",
            title: "Version Control",
            type: "collapse",
            // icon: "feather icon-navigation",
            children: [
              {
                id: "gitrepository",
                title: "Git Repository & Team",
                type: "item",
                url: "/ie/versioncontrol/repository",
              },
              {
                id: "devopsadogen2pipeline",
                title: "Gen2 ADO Pipeline",
                type: "item",
                url: "/ie/versioncontrol/adopipeline",
              },
            ],
          },
        ],
      },
      {
        id: "API Management",
        title: "API Management",
        type: "collapse",
        icon: "feather icon-grid",
        children: [
          {
            id: "Platform API",
            title: "Platform API",
            type: "collapse",
            icon: "feather icon-server",
            children: [
              {
                id: "pbetoken",
                title: "Platform Access Token",
                type: "item",
                url: "/ie/api/pbetoken",
              },
              {
                id: "pbequeryPortal",
                title: "Platform backend API",
                type: "item",
                url: "/ie/api/pbequeryPortal",
              },
              {
                id: "mmequeryPortal",
                title: "Source System API",
                type: "item",
                url: "/ie/api/mmequeryPortal",
              },
            ],
          },
          {
            id: "DataAccessAPI",
            title: "Data Access API",
            type: "collapse",
            icon: "feather icon-server",
            children: [
              {
                id: "token",
                title: "Access Token",
                type: "item",
                url: "/ie/api/token",
              },
              {
                id: "queryPorta",
                title: "Query Portal",
                type: "item",
                url: "/ie/api/queryPortal",
              },
            ],
          },
        ],
      },

      {
        id: "Business Apps",
        title: "Applications",
        type: "collapse",
        icon: "feather icon-star-on",
        children: [
          {
            id: "containercloud",
            title: "Container Cloud",
            type: "item",
            url: "/ie/applications/containercloud/",
            target: "_blank",
            // type: "collapse",
            children: [
              {
                id: "containercloud1",
                title: "Container Cloud",
                type: "item",
                icon: "feather icon-anchor",
                url: "/ie/applications/containercloud/apmterminals",
              },

              {
                id: "geoFencing",
                title: "Geo Fencing",
                type: "item",
                icon: "feather icon-map-pin",
                url: "/ie/applications/containercloud/geofencing",
              },
            ],
          },
          {
            id: "boxview",
            title: "Box View",
            type: "item",
            // type: "collapse",
            url: "/ie/applications/boxview/",
            target: "_blank",
            children: [
              {
                id: "ratool",
                title: "RA Tool",
                type: "collapse",
                icon: "feather icon-grid",
                children: [
                  {
                    id: "raalert",
                    title: "Repair Alerts",
                    type: "item",
                    icon: "feather icon-shopping-cart",
                    url: "/ie/applications/boxview/raalert/",
                  },
                  {
                    id: "shopanalysis",
                    title: "Shop Analysis",
                    type: "item",
                    icon: "feather icon-shopping-cart",
                    url: "/ie/applications/boxview/ratool/",
                  },
                ],
              },
            ],
          },
          {
            id: "pennyanalytics",
            title: "Penny Analytics",
            // type: "collapse",
            type: "item",
            url: "/ie/applications/pennyanalytics/",
            target: "_blank",
            children: [
              {
                title: "Booking Pressure & Pricing Policy",
                type: "item",
                url: "/ie/applications/pennyanalytics/bookingpressure",
                icon: "feather icon-bar-chart-2",
              },
              /*{
                title: "Initial Price Recommendations",
                type: "item",
                url:
                  "/ie/applications/pennyanalytics/initialpricerecommendations",
              },*/
              {
                title: "Penny booking alerts",
                type: "item",
                url: "/ie/applications/pennyanalytics/volumealerts",
                icon: "feather icon-alert-triangle",
              },
              {
                title: "Spot RM Health Check",
                type: "collapse",
                icon: "feather icon-activity",
                children: [
                  {
                    title: "Overview",
                    type: "item",
                    icon: "feather icon-bar-chart",
                    url: "/ie/applications/pennyanalytics/healthcheck/overview",
                  },
                  {
                    title: "Overview trades level",
                    type: "item",
                    icon: "feather icon-bar-chart-2",
                    url:
                      "/ie/applications/pennyanalytics/healthcheck/overviewtradeslevel",
                  },
                  {
                    title: "Utilization",
                    type: "item",
                    icon: "feather icon-bar-chart",
                    url:
                      "/ie/applications/pennyanalytics/healthcheck/utilization",
                  },
                  {
                    title: "Documentation",
                    type: "item",
                    icon: "feather icon-info",
                    url:
                      "/ie/applications/pennyanalytics/healthcheck/documentation",
                  },
                ],
              },
            ],
          },

          {
            id: "financeotc",
            title: "Finance OTC",
            // type: "collapse",
            type: "item",
            url: "/ie/applications/financeotc/",
            target: "_blank",
            children: [
              {
                id: "globalLpf",
                title: "Global LPF",
                type: "item",
                url: "/ie/applications/financeotc/globallpf",
                icon: "feather icon-globe",
              },
              {
                id: "lpfReport",
                title: "LPF Report",
                type: "item",
                url: "/ie/applications/financeotc/lpfReport",
                icon: "feather icon-bar-chart-2",
              },
              {
                id: "odfollowup",
                title: "OD Follow up",
                type: "item",
                url: "/ie/applications/financeotc/odfollowup",
                icon: "feather icon-bar-chart-2",
              },
              {
                id: "afrtaskcomprehensiveanalysis",
                title: "AFR Task Comprehensive analysis",
                type: "item",
                url: "/ie/applications/financeotc/afrcomprehensiveanalysis",
                icon: "feather icon-activity",
              },
              {
                id: "onaccount",
                title: "On Account",
                type: "item",
                url: "/ie/applications/financeotc/onaccount",
                icon: "feather icon-credit-card",
              },
              {
                id: "onaccountcheck",
                title: "On Account Check",
                type: "item",
                url: "/ie/applications/financeotc/onaccountcheck",
                icon: "feather icon-credit-card",
              },
              {
                id: "tqc",
                title: "TQC",
                type: "item",
                url: "/ie/applications/financeotc/tqc",
                icon: "feather icon-award",
              },
            ],
          },
          {
            id: "commercial",
            title: "Commercial",
            type: "item",
            // type: "collapse",
            url: "/ie/applications/commercial/",
            target: "_blank",
            children: [
              {
                title: "Agent View AFR",
                type: "item",
                url: "/ie/applications/commercial/agentviewafr",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Area",
                type: "item",
                url: "/ie/applications/commercial/area",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Book To Load",
                type: "item",
                url: "/ie/applications/commercial/booktoload",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Spot CCO New",
                type: "item",
                url: "/ie/applications/commercial/spotcconew",
                icon: "feather icon-bar-chart-2",
              },

              {
                title: "Belgium",
                type: "item",
                url: "/ie/applications/commercial/belgium",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Belgium OTCS",
                type: "item",
                url: "/ie/applications/commercial/thebelgium",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Cargo Readiness Check/Critical",
                type: "item",
                url: "/ie/applications/commercial/cargoreadinesscheck",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Container Overview-Grades",
                type: "item",
                url: "/ie/applications/commercial/containeroverviewgrades",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Deadline",
                type: "item",
                url: "/ie/applications/commercial/deadline",
                icon: "feather icon-bar-chart-2",
              },

              {
                title: "Downfall Management VCM",
                type: "item",
                url: "/ie/applications/commercial/downfallmanagementvcm",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Denmark",
                type: "item",
                url: "/ie/applications/commercial/thedenmark",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Denmark OTCS",
                type: "item",
                url: "/ie/applications/commercial/denmarkotcsreport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "ECare WorkStream CSAF",
                type: "item",
                url: "/ie/applications/commercial/ecareworkstream",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "ECSA Monster Report 2.0",
                type: "item",
                url: "/ie/applications/commercial/ecsamonsterreport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "ECSA Monster VAR",
                type: "item",
                url: "/ie/applications/commercial/ecsamonstervarreport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Export Customer Reference - NWC",
                type: "item",
                url: "/ie/applications/commercial/exportcustomerreferencenwc",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Fumigation",
                type: "item",
                url: "/ie/applications/commercial/fumigation",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Global HotBox Dashboard",
                type: "item",
                url: "/ie/applications/commercial/globalhotbox",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Global Rolling",
                type: "item",
                url: "/ie/applications/commercial/globalrolling",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "LAM Agent View",
                type: "item",
                url: "/ie/applications/commercial/lamagentview",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "LMW Final",
                type: "item",
                url: "/ie/applications/commercial/lmwfinal",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Netherlands OTCS",
                type: "item",
                url: "/ie/applications/commercial/netherlandotcs",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Netherlands Report",
                type: "item",
                url: "/ie/applications/commercial/netherlandreport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "NWC Empty Releases Reefer",
                type: "item",
                url: "/ie/applications/commercial/nwcemptyreleasesreefer",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "NWC Import Customer Profile",
                type: "item",
                url: "/ie/applications/commercial/nwcimport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "NWC Import Longstandings MH",
                type: "item",
                url: "/ie/applications/commercial/nwcimportlongstandingsmh",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "NWC Export Customer Profile",
                type: "item",
                url: "/ie/applications/commercial/nwcexport",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "NWC Onboarding Customers",
                type: "item",
                url: "/ie/applications/commercial/nwconboardingcustomers",
                icon: "feather icon-bar-chart-2",
              },

              /* {
                title: "NWC On Time Completion",
                type: "item",
                url: "/ie/applications/commercial/nwcontimecompletion",
              },*/
              {
                title: "Sanity Check Weight Check",
                type: "item",
                url: "/ie/applications/commercial/sanitycheckweightcheck",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "SWE FRC Report",
                type: "item",
                url: "/ie/applications/commercial/swefrc",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "SWE Open Tasks",
                type: "item",
                url: "/ie/applications/commercial/sweopentask",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "SWE Performance Dashboard",
                type: "item",
                url: "/ie/applications/commercial/sweperformance",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "Transport Plan Change Communication",
                type: "item",
                url: "/ie/applications/commercial/tpcc",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "UKI Longstandings",
                type: "item",
                url: "/ie/applications/commercial/ukilongstandings",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "VCM Pending Task",
                type: "item",
                url: "/ie/applications/commercial/vcmpendingtask",
                icon: "feather icon-bar-chart-2",
              },
              {
                title: "VCM Downfall 2",
                type: "item",
                url: "/ie/applications/commercial/vcmdownfall",
                icon: "feather icon-bar-chart-2",
              },
            ],
          },
          {
            id: "fmt",
            title: "FMT",
            type: "item",
            // type: "collapse",
            url: "/ie/applications/fmt/",
            target: "_blank",
            children: [
              {
                id: "monthendreport",
                title: "Month End Report",
                type: "item",
                url: "/ie/applications/fmt/monthendreport",
                icon: "feather icon-bar-chart-2",
              },
            ],
          },
          {
            id: "intermodal",
            title: "InterModal",
            // type: "collapse",
            type: "item",
            url: "/ie/applications/intermodal/",
            target: "_blank",
            children: [
              {
                id: "additional_charges",
                title: "Additional Charges",
                type: "item",
                url: "/ie/applications/intermodal/additional-charges",
                icon: "feather icon-trending-up",
              },
              {
                id: "additionalcharges",
                title: "Additional Charges - Reports",
                type: "item",
                url: "/ie/applications/intermodal/additionalcharges",
                icon: "feather icon-bar-chart",
              },
            ],
          },

          {
            id: "gcaoce",
            title: "GCAOCE",
            type: "item",
            // type: "collapse",
            url: "/ie/applications/gcaoce/",
            target: "_blank",
            children: [
              {
                id: "exportBookingReport",
                title: "EXP/IMP Booking",
                type: "item",
                url: "/ie/applications/gcaoce/exportbooking",
                icon: "feather icon-edit",
              },
              {              
                id: "gcarolling",
                title: "GCA Rolling",
                type: "item",
                url: "/ie/applications/gcaoce/gcarolling",
                icon: "feather icon-crosshair",
              },
              {
                id: "gcaocependingtasks",
                title: "Customer Data",
                type: "item",
                url: "/ie/applications/gcaoce/customerdata",
                icon: "feather icon-alert-octagon",
              },
              {
                id: "gcapfvdashboard",
                title: "GCA PFV Dashboard",
                type: "item",
                url: "/ie/applications/gcaoce/contactdistributionlist",
                icon: "feather icon-monitor",
              },
              {
                id: "gcacarelist",
                title: "GCA CPS",
                type: "item",
                url: "/ie/applications/gcaoce/gcacps",
                icon: "feather icon-list",
              },
              {
                id: "shipmentpartyemailphone",
                title: "GCA CM",
                type: "item",
                url: "/ie/applications/gcaoce/gcacm",
                icon: "feather icon-mail",
              },
              {
                id: "etachangemonitor",
                title: "E2E ETD_ETA Change Monitoring",
                type: "item",
                url: "/ie/applications/gcaoce/etachangemonitor",
                icon: "feather icon-activity",
              },
              {
                id: "shipmentlist",
                title: "Longstanding",
                type: "item",
                url: "/ie/applications/gcaoce/gcalongstanding",
                icon: "feather icon-list",
              },
              {
                id: "cbpmappingtool",
                title: "Other Report1",
                type: "item",
                url: "/ie/applications/gcaoce/otherreport1",
                icon: "feather icon-settings",
              },
              {
                id: "equcontroltool",
                title: "Other Report2",
                type: "item",
                url: "/ie/applications/gcaoce/otherreport2",
                icon: "feather icon-box",
              },

              {
                id: "paymentcheck",
                title: "Other Report3",
                type: "item",
                url: "/ie/applications/gcaoce/otherreport3",
                icon: "feather icon-check-square",
              },
            ],
          },

          /* {
            id: "triton",
            title: "Triton",
            type: "item",
            url: "/ie/applications/triton",
          }, */
          {
            id: "rock",
            title: "Rock",
            type: "item",
            url: "/ie/applications/rock",
          },
          {
            id: "apamirror",
            title: "APA Mirror",
            type: "item",
            target: "_blank",
            url: "/ie/applications/apamirror/",
            children: [
              {
                id: "hyosung",
                title: "Hyosung",
                icon: "feather icon-bar-chart",
                type: "item",
                url: "/ie/applications/apamirror/hyosung",
                accessTo: [HYOSUNG_READER, MAESTRO_ADMIN],
              },
              {
                id: "kumbho",
                title: "Kumho",
                icon: "feather icon-bar-chart",
                type: "item",
                url: "/ie/applications/apamirror/kumho",
                accessTo: [KUMHO_READER, MAESTRO_ADMIN],
              },
              {
                id: "booking",
                title: "Customer Booking Performance (Global)",
                icon: "feather icon-bar-chart",
                type: "item",
                url: "/ie/applications/apamirror/bookingotd",
              },
              {
                id: "customerallocation",
                title: "Customer Allocation Fulfillment (Global)",
                icon: "feather icon-bar-chart",
                type: "item",
                url: "/ie/applications/apamirror/customerallocation",
              },
            ],
          },
        ],
      },

      {
        id: "Data Transformation",
        title: "Data Transformation",
        icon: "feather icon-aperture",
        type: "collapse",
        children: [
          {
            title: "Master Data Quality",
            type: "collapse",
            children: [
              {
                title: "Customer 2.0",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/customermasterdata",
              },

              {
                title: "Vendor",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/vendor",
              },
              {
                title: "Geography",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/geography",
              },
              {
                title: "Vessel",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/vessel",
              },
              {
                title: "Facility",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/facility",
              },
              {
                title: "Commodity",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/commodity",
              },
              {
                title: "HR(Employee)",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/hr",
              },
            ],
          },
          {
            //Infrastructure
            id: "Maestro Products",
            title: "Products",
            type: "collapse",
            // icon: "feather icon-cloud-drizzle",
            // url: "/ie/admin/productspage",
            children: [
              {
                id: "productdetails",
                title: "Existing Products",
                type: "item",
                url: "/ie/admin/productspage",
              },
              // {
              //   id: "newmanagedproduct",
              //   title: "New Managed Product",
              //   type: "item",
              //   url: "/ie/admin/createmanagedproduct",
              // },
              // {
              //   id: "newstandaloneproduct",
              //   title: "New Standalone Product",
              //   type: "item",
              //   url: "/ie/admin/createstandaloneproduct",
              // },
              // {
              //   id: "newsourceproduct",
              //   title: "New Source Product",
              //   type: "item",
              //   url: "/ie/admin/createsourceproduct",
              // },
            ],
          },
          //insights
          {
            id: "Insights",
            title: "Insights",
            type: "collapse",
            // icon: "feather icon-bar-chart",

            children: [
              {
                id: "alyticsoverview",
                title: "Overview",
                type: "item",
                url: "/ie/applications/insights/overview",
              },
              {
                id: "clarity",
                title: "Clarity",
                type: "item",
                url:
                  "https://clarity.microsoft.com/projects/view/bd9l1n9sgx/dashboard?date=Last%203%20days&Source=maestro.insights.maersk.com",
                target: true,
                external: true,
              },
            ],
          },
          //   Data Lakes
          // {
          //   id: "Data Governance",
          //   title: "Data Governance",
          //   type: "collapse",
          //   // icon: "feather icon-layers",
          //   children: [
          // {
          //   id: "dataLakeDirectories",
          //   title: "Manage ADLS Directory",
          //   type: "item",
          //   url: "/ie/admin/dldirectories",
          // },
          {
            id: "dataaccessapprovals",
            title: "ADLS Governance",
            type: "collapse",
            children: [
              {
                id: "dataaccessRequest",
                title: "Access Request",
                type: "item",
                url: "/ie/admin/accessRequests",
              },
              {
                id: "accessRequestDashboard",
                title: "My Request Status",
                type: "item",
                url: "/ie/admin/requestdashboard",
              },
              {
                id: "dataaccessapprovalsChild",
                title: "Request Approval Window",
                type: "item",
                url: "/ie/admin/accessApprovals",
                accessTo: [MAESTRO_ADMIN, MAESTRO_ADLS_ADMIN],
              },
              // {
              //   id: "dataaccesConfiguresapprovals",
              //   title: "Configure Data Directory",
              //   type: "item",
              //   url: "/ie/admin/configureApprovals",
              //   accessTo: [MAESTRO_ADMIN, MAESTRO_ADLS_ADMIN],
              // },
              // {
              //   id: "accessRemoval",
              //   title: "Access Removal Window",
              //   type: "item",
              //   url: "/ie/admin/accessremoval",
              //   accessTo: [MAESTRO_ADMIN, MAESTRO_ADLS_ADMIN],
              // },
            ],
          },
          //   ],
          // },
          {
            id: "Cost",
            title: "Cost Overview",
            type: "collapse",
            // icon: "feather icon-target",

            children: [
              {
                id: "powerbipowerapps",
                title: "PowerBI vs PowerApps",
                type: "item",
                url: "/ie/applications/PowerBIPowerApps/powerappsreport",
              },
              {
                id: "dremiopowerbi",
                title: "Dremio PowerBi Testing",
                type: "item",
                url: "/ie/applications/PowerBIDremio",
              },
            ],
          },

          {
            id: "Data Quality",
            title: "Data Quality",
            type: "collapse",

            children: [
              {
                title: "Customer Journey",
                type: "item",
                url: "/ie/applications/customerjourney",
              },
              {
                title: "Data Ingestion Quality",
                type: "item",
                url: "/ie/applications/maestrodataingestionquality",
              },
              {
                title: "Definitions of Data Quality",
                type: "item",
                url:
                  "/ie/applications/enterprisedataquality/masterdataquality/definationsofdataquality",
              },
              {
                id: "Catalogue",
                title: "Enterprise Catalogue",
                type: "item",
                url: "/ie/applications/catalogue",
              },
            ],
          },
        ],
      },

      //onboarding
    ],
  },
];
export default class Menuitems {
  menu() {
    this.aadService = new AADService();
    let role = this.aadService.getRoles();
    let naviGation = [];

    if (role && role.includes(DEMO.MAESTRO_ADMIN)) {
      naviGation = this.menuGenerator(DEMO.MAESTRO_ADMIN);
    } else if (role && role.includes(DEMO.MAESTRO_ADLS_ADMIN)) {
      naviGation = this.menuGenerator(DEMO.MAESTRO_ADLS_ADMIN);
    } else if (role && role.includes(DEMO.MAESTRO_MIRROR_READER_KUMHO)) {
      naviGation = this.menuGenerator(DEMO.MAESTRO_MIRROR_READER_KUMHO);
    } else if (role && role.includes(DEMO.MAESTRO_MIRROR_READER_HYOSUNG)) {
      naviGation = this.menuGenerator(DEMO.MAESTRO_MIRROR_READER_HYOSUNG);
    } else {
      // Give the user default role when they are not associated with any role.
      naviGation = this.menuGenerator(DEMO.MAESTRO_REQUESTER);
    }
    //for opening in new tab in maestro apps
    naviGation = this.appcheck(naviGation);
    return naviGation;
  }
  appcheck(naviGation) {
    let loc = window.location.pathname.split("/");
    const path = loc[3];
    switch (path) {
      case "boxview":
        this.mappVisibility(path, naviGation);
        break;
      case "containercloud":
        this.mappVisibility(path, naviGation);
        break;
      case "pennyanalytics":
        this.mappVisibility(path, naviGation);
        break;
      case "financeotc":
        this.mappVisibility(path, naviGation);
        break;
      case "commercial":
        this.mappVisibility(path, naviGation);
        break;
      case "fmt":
        this.mappVisibility(path, naviGation);
        break;
      case "intermodal":
        this.mappVisibility(path, naviGation);
        break;
      case "gcaoce":
        this.mappVisibility(path, naviGation);
        break;
      case "apamirror":
        this.mappVisibility(path, naviGation);
        break;
      default:
        return naviGation;
    }
    return naviGation;
  }
  mappVisibility(itemTobeEnabled, naviGation) {
    let naviGationNew = [];
    naviGation[0].children.map((child, ind1) => {
      if (child.id === "Business Apps") {
        if (child.children) {
          child.children.map((grandChild, ind2) => {
            if (grandChild.id === itemTobeEnabled) {
              if (grandChild.children) {
                naviGationNew.push(grandChild.children);
              }
            }
          });
        }
      }
      return naviGationNew;
    });
    delete naviGation[0].children;
    naviGation[0] = { ...naviGation[0], children: naviGationNew[0] };
    return naviGation;
  }
  menuGenerator(role) {
    let naviGation = [];
    items &&
      items.map((item, index) => {
        naviGation.push({
          id: item.id,
          title: item.title,
          type: item.type,
          icon: item.icon,
          children: [],
        });
        if (item.children) {
          item.children.map((collapse, indx) => {
            let flag =
              typeof collapse.accessTo !== "undefined" &&
                !collapse.accessTo.includes(role)
                ? true
                : false;

            if (!flag) {
              naviGation[index].children[indx] = collapse;
              if (collapse.children) {
                collapse.children.map((collapse1, indx1) => {
                  let childflag =
                    typeof collapse1.accessTo === "undefined"
                      ? true
                      : collapse1.accessTo && collapse1.accessTo.includes(role)
                        ? true
                        : false;

                  if (!childflag) {
                    delete naviGation[index].children[indx].children[indx1];
                  } else {
                    naviGation[index].children[indx].children[
                      indx1
                    ] = collapse1;
                    if (collapse1.children) {
                      collapse1.children.map((collapse2, indx2) => {
                        let grandchildflag =
                          typeof collapse2.accessTo === "undefined"
                            ? true
                            : collapse2.accessTo &&
                              collapse2.accessTo.includes(role)
                              ? true
                              : false;

                        if (!grandchildflag) {
                          delete naviGation[index].children[indx].children[
                            indx1
                          ].children[indx2];
                        } else {
                          naviGation[index].children[indx].children[
                            indx1
                          ].children[indx2] = collapse2;
                        } // end of grndchldflg
                      });
                    }
                  } // end of chldflg
                });
              }
            } //end of flag
          });
          // }
        }
        return naviGation;
      });
    return naviGation;
  }
}
